import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Gallery from "../components/Gallery/Gallery"

const GalleryPage = ({location}) => {
	return (
		<Layout location={location}>
			<Seo title="Gallery" />
			<Gallery></Gallery>
		</Layout>
	)
}

export default GalleryPage
